import { clsx } from 'clsx';
import { FC } from 'react';
import { H1, P, Span } from 'atoms/Typography';
import { WizardHeaderProps } from '../data/types';
import styles from './styles.module.css';

export const WizardHeader: FC<WizardHeaderProps> = ({
  image,
  heading,
  subHeading,
}) => {
  return (
    <section className={styles.sectionHead}>
      <H1 className={styles.headline}>{heading}</H1>
      <P className={styles.subLine}>
        <Span className={clsx(styles.subHeading, styles.isActive)}>
          {subHeading}
        </Span>
      </P>
      <div className={styles.profileImage}>
        <div className={styles.backgroundImage}></div>
        <div
          className={clsx(
            styles.backgroundImage,
            styles.isActive,
            styles.isVisible,
            styles.canScale,
          )}
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      </div>
    </section>
  );
};
